import {TaxiMessage} from "./taxi-message";

export class TaxiSearchError implements TaxiMessage {
  constructor(public draftId: number) {}

  getDraftId(): number {
    return this.draftId;
  }
}
